import { render } from "./forgotpassword.vue?vue&type=template&id=34258f57&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"

import "./forgotpassword.vue?vue&type=style&index=0&id=34258f57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34258f57"]])

export default __exports__